import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, AfterViewInit, OnDestroy} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TeiasoftModalService } from '../../services/teiasoft-bucket/teiasoft-modal.service';
import { BackendService } from '../../services/backend/backend.service';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { Globals } from '../../globals/globals';
import { SelectOption } from '../../teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { CreateEnquiryCustomer } from '../../models/data/createEnquiry.model';
import { Country } from '../../models/data/country.model';
declare var $:any;

@Component({
  selector: 'app-create-edit-dummy',
  templateUrl: './create-edit-dummy.component.html',
  styleUrls: ['./create-edit-dummy.component.scss']
})
export class CreateEditDummyComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() isCreate: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
  @Input() placeHolder: string = "";
  @Input() isValid: boolean = true;
  @Input() dummyCustomer: CreateEnquiryCustomer = new CreateEnquiryCustomer();
  @Input() countries: Country[] = new Array();

  @Output() onCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() onSavaData: EventEmitter<CreateEnquiryCustomer> = new EventEmitter();

  modalTitle: string = "";
  nameisValid: boolean = true;
  countryisValid: boolean = true;
  unitSystemIsValid: boolean = true;

  name = "";
  country = "";
  
  // TEMP
  customerCountries: SelectOption[] = new Array(); 
  clearValueCountry: boolean = false;
  clearValueUnitSystem: boolean = false;
  private sourceCountries: Country[] = new Array();

  listOfOptions: SelectOption[] = [
    { value: 'Metric', text: this.translateService.instant("enquiryBook.metric") },
    { value: 'Imperial', text: this.translateService.instant("enquiryBook.imperial") }
  ];

  constructor(private translateService: TranslateService, private backendService: BackendService, private teiasoftModalService: TeiasoftModalService,
    private teiasoftToaster: TeiasoftToasterService, public globals: Globals, private teiasoftLoader: TeiasoftLoaderService
  ) {
  }
  ngOnDestroy(): void {
    this.dummyCustomer = new CreateEnquiryCustomer();
  }


  ngOnInit(): void {
    if (this.isCreate)
      this.dummyCustomer = new CreateEnquiryCustomer();
  }

  ngAfterViewInit(): void {
    setTimeout(() => 
      {
        $('.ti-input').focus();
        this.clearValueCountry = true;
        this.clearValueUnitSystem = true;
        setTimeout(() => {
          this.clearValueCountry = false;
          this.clearValueUnitSystem = false;
        }, 200);
      }, 100)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["isCreate"]) {
      this.dummyCustomer = new CreateEnquiryCustomer();
      this.isCreate = changes["isCreate"].currentValue;
      
      if (this.isCreate)
        this.modalTitle = this.translateService.instant("toolbar.createDummy");
      else
        this.modalTitle = this.translateService.instant("toolbar.editDummy");
    }

    if (changes && changes["dummyCustomer"]){
      this.dummyCustomer = new CreateEnquiryCustomer();
      this.dummyCustomer = changes["dummyCustomer"].currentValue;
    }

    if (changes && changes["countries"]){
      this.countries = new Array();
      this.countries = changes["countries"].currentValue;
      this.fillCountries();
    }
  }

  fillCountries(){
    this.customerCountries = new Array();
    this.sourceCountries = this.countries;
    for (var x=0; x < this.countries.length; x++){
      let _item: SelectOption= new SelectOption();
      _item.text = this.decodeSpecialChars(this.countries[x].countryName!);
      _item.value = this.countries[x].countryId;
      this.customerCountries.push(_item);
    }
  }

  decodeSpecialChars(val:string):string {
    let _element = document.createElement('div');
    val = val.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
    val = val.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
    _element.innerHTML = val;
    val = _element.textContent!;
    _element.textContent = '';
    return val;
}

  getSelectText(value: string):string{
    return this.listOfOptions.find(x => x.value == value)!.text;
  }

  validateForm():boolean{
    let _isValid: boolean = true;
    if (!this.dummyCustomer.customerName || this.dummyCustomer.customerName == ''){
      this.nameisValid = false;
      _isValid =  false;
    }

    if (!this.dummyCustomer.customerCountryId){
      this.countryisValid = false;
      _isValid =  false;
    }

    if (!this.dummyCustomer.unitSystem || this.dummyCustomer.unitSystem == ''){
      this.unitSystemIsValid = false;
      _isValid =  false;
    }

    return _isValid;
  }

  onConfirmModalClick() {
    if (this.validateForm()) {
      this.onSavaData.emit(this.dummyCustomer);      
    }
  }

  onCloseModalClick() {
    this.onCloseModal.emit('');
  }

  onInput(evt:string, field: string){
    if (field == 'customerName'){
      this.dummyCustomer.customerName = evt;
      this.nameisValid = true;
    } else {
      //this.dummyCustomer.customerCountryId = 99999; // = evt;
      //this.dummyCustomer.countryName = evt;
      this.countryisValid = true;
    }
  }

  onSelected(evt: SelectOption, field: string){
    if (field == 'UnitSystem'){
      this.dummyCustomer.unitSystem = evt.value!;
      this.unitSystemIsValid = true;
    }

    if (field == 'CountryName'){
      this.dummyCustomer.customerCountryId = evt.value!;
      this.dummyCustomer.currency = this.sourceCountries.find(country => country.countryId == evt.value)?.defaultCurrency ?? '';
      this.countryisValid = true;
    }
  }

}
